import {
  GET_CARRIER_CONFIGURATION_LIST_FAILURE,
  GET_CARRIER_CONFIGURATION_LIST_REQUEST,
  GET_CARRIER_CONFIGURATION_LIST_SUCCESS,
  ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE,
  ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST,
  ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS,
  GET_CARRIER_MILESTONE_LIST_FAILURE,
  GET_CARRIER_MILESTONE_LIST_SUCCESS,
  GET_CARRIER_MILESTONE_LIST_REQUEST,
  GET_MILESTONE_LOOKUP_REQUEST,
  GET_MILESTONE_LOOKUP_SUCCESS,
  GET_MILESTONE_LOOKUP_FAILURE,
  ADD_UPDATE_CARRIER_MILESTONE_REQUEST,
  ADD_UPDATE_CARRIER_MILESTONE_FAILURE,
  ADD_UPDATE_CARRIER_MILESTONE_SUCCESS,
  GET_CARRIER_ACTIVITY_LIST_FAILURE,
  GET_CARRIER_ACTIVITY_LIST_REQUEST,
  GET_CARRIER_ACTIVITY_LIST_SUCCESS,
  GET_CARRIER_CONFIGURATION_DETAILS_FAILURE,
  GET_CARRIER_CONFIGURATION_DETAILS_REQUEST,
  GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS,
} from "./actionTypes";
import {
  CarrierTrackingState,
  CarrierTrackingActions,
  CarrierConfigurationList,
  CarrierMilestone,
  MilestoneLookup,
  CarrierActivityList,
} from "./types";

const initialState: CarrierTrackingState = {
  pending: false,
  error: null,
  successMessage: "",
  isLoadingScreen: false,
  carrierConfigurationList: [] as CarrierConfigurationList[],
  carrierConfigurationDetails: [] as CarrierConfigurationList[],
  carrierMilestoneList: [] as CarrierMilestone[],
  milestoneLookupList: [] as MilestoneLookup[],
  carrierActivityList: [] as CarrierActivityList[],
};

const carrierTrackingReducer = (
  state = initialState,
  action: CarrierTrackingActions,
) => {
  switch (action.type) {
    case GET_CARRIER_CONFIGURATION_LIST_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_CARRIER_CONFIGURATION_LIST_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        carrierConfigurationList: action.payload?.carrierConfiguration,
      };
    case GET_CARRIER_CONFIGURATION_LIST_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    case GET_CARRIER_CONFIGURATION_DETAILS_REQUEST:
      return {
        ...state,
      };
    case GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS:
      return {
        ...state,
        carrierConfigurationDetails: action.payload?.carrierConfiguration,
      };
    case GET_CARRIER_CONFIGURATION_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action?.payload?.successMessage,
        error: null,
      };
    case ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_CARRIER_MILESTONE_LIST_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_CARRIER_MILESTONE_LIST_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        carrierMilestoneList: action.payload?.carrierMilestone,
      };
    case GET_CARRIER_MILESTONE_LIST_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    case GET_MILESTONE_LOOKUP_REQUEST:
      return {
        ...state,
        isloadingMilestoneLookup: true,
      };
    case GET_MILESTONE_LOOKUP_SUCCESS:
      return {
        ...state,
        isloadingMilestoneLookup: false,
        milestoneLookupList: action.payload?.milestoneLookup,
      };
    case GET_MILESTONE_LOOKUP_FAILURE:
      return {
        ...state,
        isloadingMilestoneLookup: false,
        error: action.payload.error,
      };
    case ADD_UPDATE_CARRIER_MILESTONE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_UPDATE_CARRIER_MILESTONE_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action?.payload?.successMessage,
        error: null,
      };
    case ADD_UPDATE_CARRIER_MILESTONE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_CARRIER_ACTIVITY_LIST_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_CARRIER_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        carrierActivityList: action.payload?.carrierActivity,
      };
    case GET_CARRIER_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

export default carrierTrackingReducer;
